// extracted by mini-css-extract-plugin
export default {"tabsContainer":"AirdropPage_tabsContainer__hrVMQ","tabItem":"AirdropPage_tabItem__OTFpI","active":"AirdropPage_active__j2GP0","disabled":"AirdropPage_disabled__s7aoy"};